export default {
  getUsers: state => state.users,
  getDadosAuditoria: state => state.dadosAuditoria,
}
